import React, {useState, useEffect} from "react";
import BackButton from "components/Button/BackButton";
import SaveButton from "components/Button/SaveButton";
import DeleteButton from "components/Button/DeleteButton";
import useFetch from "utils/hooks/useFetch";
import { useNavigate } from "react-router-dom";
import { ApiResponseStatusUnauthorized, ApiResponseSuccess, EmptyString, FormTypeAdd, FormTypeEdit, ModalTypeConfirmation, ModalTypeFail, ModalTypeLoading, ModalTypeSuccess } from "utils/Constant";
import { ApiCheckIsAdmin, ApiDeleteUser, ApiGetUserById, ApiRegister, ApiUpdateUser } from "utils/constants/api";
import { GetStatus } from "utils/helpers";
import moment from "moment";
import UnDeleteButton from "components/Button/UnDeleteButton";
import { useModal } from "components/modal/ModalContext";

export default function UserForm(){
    let navigate = useNavigate()
    const { openModal, closeModal } = useModal()

    const { fetch: apiRegisterUser } = useFetch(ApiRegister)
    const { fetch: apiUpdateUser } = useFetch(ApiUpdateUser)
    const { fetch: apiGetUserById } = useFetch(ApiGetUserById)
    const { fetch: apiDeleteUser } = useFetch(ApiDeleteUser)
    const { fetch: apiCheckIsAdmin } = useFetch(ApiCheckIsAdmin)

    let queryString = new URLSearchParams(window.location.search)
    let formType = queryString.get("formType")
    let paramUserId = queryString.get("userId")
    
    const [username, setUsername] = useState(EmptyString)
    const [name, setName] = useState(EmptyString)
    const [password, setPassword] = useState(EmptyString)
    const [confirmPassword, setConfirmPassword] = useState(EmptyString)
    const [isAdmin, setIsAdmin] = useState(false)
    const [status, setStatus] = useState(EmptyString)
    const [createDate, setCreateDate] = useState(EmptyString)
    const [updateDate, setUpdateDate] = useState(EmptyString)
    const [updateBy, setUpdateBy] = useState(EmptyString)

    const [errorUsername, setErrorUsername] = useState(false)
    const [errorName, setErrorName] = useState(false)
    const [errorPassword, setErrorPassword] = useState(false)
    const [errorConfirmPassword, setErrorConfirmPassword] = useState(false)
    const [errorConfirmPasswordMessage, setErrorConfirmPasswordMessage] = useState(EmptyString)
    
    // Button Event
    const saveBtnClick = () => {
        if(fFormValidation()){
            openModal(ModalTypeConfirmation, {
                onConfirm: () => {
                    openModal(ModalTypeLoading)
    
                    if (formType === FormTypeAdd) {
                        insertUser()
                    } else {
                        updateUser()
                    }
                }
            })
        }
    }
    const deleteBtnClick = () => {
        openModal(ModalTypeConfirmation, {
            onConfirm: () => {
                openModal(ModalTypeLoading)

                deleteUser(paramUserId, status === 1 ? '2' : '1')
            }
        })
    }
    const backBtnClick = () => {
        navigate(-1)
    }
    
    // API Calls
    const insertUser = async() => {
        await apiRegisterUser({
            data: {
                username: username,
                fullName: name,
                password: password,
                isAdmin: isAdmin
            }
        }).then((response) => {
            if (checkResponse(response)) {
                openModal(ModalTypeSuccess, {
                    onSuccess: () => {
                        navigate("/setting/user") 
                    }
                })
            }
        })
    }
    const updateUser = async() => {
        await apiUpdateUser({
            data: {
                userId: paramUserId,
                username: username,
                fullName: name,
                password: password,
                isAdmin: isAdmin
            }
        }).then((response) => {
            if (checkResponse(response)) {
                openModal(ModalTypeSuccess, {
                    onSuccess: () => {
                        navigate("/setting/user") 
                    }
                })
            }
        })
    }
    const deleteUser = async(id, status) => {
        await apiDeleteUser({
            data: {
                userId: id,
                status: status
            }
        }).then((response) => {
            if (checkResponse(response)) {
                openModal(ModalTypeSuccess, {
                    onSuccess: () => {
                        closeModal()
                        navigate("/setting/user") 
                    }
                })
            }
        })
    }
    const getUserById = async(paramUserId) => {
        await apiGetUserById({
            data: {
                userId: paramUserId
            }
        }).then((response) => {
            if (checkResponse(response)) {
                let data = response.data

                setUsername(data.username)
                setName(data.fullName)
                setIsAdmin(data.isAdmin)
                setStatus(data.status)
                setCreateDate(data.createdDate)
                setUpdateDate(data.updatedDate)
                setUpdateBy(data.updatedBy)
            }
        })
    }
    const checkIsAdmin = async() => {
        await apiCheckIsAdmin({
            data: {
                userId: localStorage.getItem("Id")
            }
        }).then((response) => {
            if (checkResponse(response)){
                if (response.data.isAdmin === false){
                    localStorage.setItem("IsAdmin", "0")
                    window.location.href = "/"
                }
            }
        })
    }

    // Function
    function fFormValidation(){
        let errorCount = 0

        if (username === EmptyString || username === null){
            setErrorUsername(true)
            errorCount++
        }else{
            setErrorUsername(false)
        }

        if (name === EmptyString || name === null){
            setErrorName(true)
            errorCount++
        }else{
            setErrorName(false)
        }

        if (password === EmptyString || password === null){
            setErrorPassword(true)
            errorCount++
        }else{
            setErrorPassword(false)
        }

        if (confirmPassword === EmptyString || confirmPassword === null){
            setErrorConfirmPasswordMessage("Confirm Password is required")
            setErrorConfirmPassword(true)
            errorCount++
        }else{
            setErrorConfirmPassword(false)
        }

        if(errorCount > 0){
            return false
        }else{
            return true
        }
    }
    function fHandleConfirmPasswordInput(value){
        if (password !== value){
            setErrorConfirmPasswordMessage("Password did not match!")
            setErrorConfirmPassword(true)
        }else{
            setErrorConfirmPassword(false)
        }
    }

    const checkResponse = (res) => {
        if (res.status === ApiResponseSuccess) {
            return true
        } else if (res.status === ApiResponseStatusUnauthorized) {
            window.location.href = "/login"
            return false
        } else {
            openModal(ModalTypeFail, { message: res.message })
            return false
        }
    }
    
    useEffect(() => {
        openModal(ModalTypeLoading)

        checkIsAdmin().then(() => {
            if (formType === FormTypeEdit){
                getUserById(paramUserId).then(() => {
                    closeModal()
                })
            }else{
                closeModal()
            }
        })
    }, [])

    return(
        <div className="flex p-3 min-h-full w-full">
            <div className="flex flex-col border justify-between gap-2 sm:bg-white sm:p-6 sm:rounded-xl sm:shadow-lg min-h-full w-full">
                <div>
                    <div className="flex justify-between">
                        <span className="font-semibold text-2xl">User Detail</span>
                        <div className={`flex gap-2 items-end justify-end ${ formType === FormTypeAdd ? 'hidden' : 'block'}`}>
                            <span className="text-sm opacity-60">
                                Status : {GetStatus(status)} | Created Date : {moment(createDate).format("DD MMM yyyy")} | Last Updated : {moment(updateDate).format("DD MMM yyyy")} | Updated By : {updateBy}
                            </span>
                        </div>
                    </div>
                    <hr />

                    <div className="mt-5 flex flex-col gap-3">
                        {/* Username */}
                        <div>
                            <div className="flex flex-col sm:flex-row sm:items-center">
                                <div className="w-48">
                                    <span>Username</span>
                                </div>
                                <div className="px-4 hidden sm:block">
                                    <span>:</span>
                                </div>
                                <div className="w-full sm:w-72">
                                    <input className="input" value={ username } onChange={(e) => { setUsername(e.target.value) }} maxLength={20} disabled={formType === FormTypeEdit ? true : false} />
                                </div>
                            </div>
                            <div className={`flex items-center ${errorUsername ? 'block' : 'hidden'}`}>
                                <div className="w-48" />
                                <div className="w-9" />
                                <span className="text-red-500">Username is required!</span>
                            </div>
                        </div>

                        {/* Name */}
                        <div>
                            <div className="flex flex-col sm:flex-row sm:items-center">
                                <div className="w-48">
                                    <span>Name</span>
                                </div>
                                <div className="px-4 hidden sm:block">
                                    <span>:</span>
                                </div>
                                <div className="w-full sm:w-72">
                                    <input className="input" value={name} onChange={(e) => { setName(e.target.value) }} maxLength={30} />
                                </div>
                            </div>
                            <div className={`flex items-center ${ errorName ? 'block' : 'hidden' }`}>
                                <div className="w-48" />
                                <div className="w-9" />
                                <span className="text-red-500">Name is required!</span>
                            </div>
                        </div>

                        {/* Password */}
                        <div>
                            <div className="flex flex-col sm:flex-row sm:items-center">
                                <div className="w-48">
                                    <span>Password</span>
                                </div>
                                <div className="px-4 hidden sm:block">
                                    <span>:</span>
                                </div>
                                <div className="w-full sm:w-72">
                                    <input type="password" className="input" value={password} onChange={(e) => { setPassword(e.target.value) }} />
                                </div>
                            </div>
                            <div className={`flex items-center ${ errorPassword ? 'block' : 'hidden' }`}>
                                <div className="w-48" />
                                <div className="w-9" />
                                <span className="text-red-500">Password is required!</span>
                            </div>
                        </div>

                        {/* Confirm Password */}
                        <div>
                            <div className="flex flex-col sm:flex-row sm:items-center">
                                <div className="w-48">
                                    <span>Confirm Password</span>
                                </div>
                                <div className="px-4 hidden sm:block">
                                    <span>:</span>
                                </div>
                                <div className="w-full sm:w-72">
                                    <input type="password" className="input" value={confirmPassword} onChange={(e) => {setConfirmPassword(e.target.value)}} onInput={(e) => { fHandleConfirmPasswordInput(e.target.value) }} />
                                </div>
                            </div>
                            <div className={`flex items-center ${ errorConfirmPassword ? 'block' : 'hidden' }`}>
                                <div className="w-48" />
                                <div className="w-9" />
                                <span className="text-red-500">{ errorConfirmPasswordMessage }</span>
                            </div>
                        </div>

                        {/* Admin */}
                        <div>
                            <div className="flex items-center">
                                <div className="w-48">
                                    <span>Admin</span>
                                </div>
                                <div className="px-4 hidden sm:block">
                                    <span>:</span>
                                </div>
                                <div className="w-full sm:w-72 flex items-center">
                                    <input type="checkbox" className="" value={isAdmin} onChange={(e) => {setIsAdmin(!isAdmin)}} checked={isAdmin} />
                                </div>
                            </div>
                        </div>

                        {/* Button */}
                        <div className="mt-5 flex flex-wrap justify-end gap-2">
                            <SaveButton onClick={saveBtnClick} visible={true} />
                            <DeleteButton onClick={deleteBtnClick} visible={formType === FormTypeEdit ? (status === '1' ? true : false) : false} />
                            <UnDeleteButton onClick={deleteBtnClick} visible={formType === FormTypeEdit ? (status === '2' ? true : false) : false} />
                            <BackButton onClick={backBtnClick} />
                        </div>
                    </div>
                </div>
                
            </div>
            
        </div>
    )
}